import Swiper, { Pagination } from 'swiper'
import device from '../helpers/device'

Swiper.use([Pagination])

class SliderCare {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.initSlider()
  }

  bindUI() {
    this.ui = {}
    this.ui.$slider = this.el.querySelector('.swiper')
    this.ui.$pagination = this.el.querySelector('.swiper-pagination')
    this.ui.$slides = this.el.querySelectorAll('.swiper-slide')
    this.ui.$prevButton = this.el.querySelector('.swiper-pagination-button-prev')
    this.ui.$nextButton = this.el.querySelector('.swiper-pagination-button-next')
    this.ui.$currentSlide = this.el.querySelector('.swiper-pagination-current')
    this.ui.$totalSlides = this.el.querySelector('.swiper-pagination-total')
  }

  initSlider() {
    if (!this.ui.$slider) {
      return
    }

    this.slider = new Swiper(this.ui.$slider, {
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      loop: false,
      autoHeight: true,
      navigation: {
        nextEl: this.ui.$nextButton,
        prevEl: this.ui.$prevButton,
      },
      on: {
        init: (swiper) => {

          this.updatePagination(swiper)
        },
        slideChange: (swiper) => {

          this.updatePagination(swiper)
        }
      }
    })

    // Test manual event listeners
    if (this.ui.$prevButton) {
      this.ui.$prevButton.addEventListener('click', (e) => {
        e.preventDefault()
        if (this.slider) {
          this.slider.slidePrev()
        }
      })
    }

    if (this.ui.$nextButton) {
      this.ui.$nextButton.addEventListener('click', (e) => {
        e.preventDefault()
        if (this.slider) {
          this.slider.slideNext()
        }
      })
    }
  }

  updatePagination(swiper = this.slider) {
    if (this.ui.$currentSlide && this.ui.$totalSlides && swiper) {
      const current = swiper.activeIndex + 1
      const total = this.ui.$slides.length
      this.ui.$currentSlide.textContent = current
      this.ui.$totalSlides.textContent = total
    }
  }
}

export default SliderCare 